import { Component, computed, input, model } from '@angular/core';
import { BaseConfig } from '../common/config/config.adapter';
import { PageInfo } from '../common/types';

@Component({
  selector: 'lepi-pagination',
  standalone: true,
  imports: [],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.css',
})
export class Pagination extends BaseConfig {
  pageInfo = input.required<PageInfo>();
  pageNo = model(1);

  pages = computed(() => {
    const totalPages = this.pageInfo()?.totalPages || 1;
    const currentPage = this.pageNo();

    const pages = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      let start = Math.max(1, currentPage - 2);
      let end = Math.min(totalPages, currentPage + 2);

      if (currentPage <= 3) {
        start = 1;
        end = 5;
      } else if (currentPage >= totalPages - 2) {
        start = totalPages - 4;
        end = totalPages;
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
    }

    return pages;
  });

  isFirstDisabled = computed(() => this.pageNo() === 1);
  isLastDisabled = computed(
    () =>
      this.pageNo() === (this.pageInfo()?.totalPages || 1) ||
      (this.pageInfo()?.totalItems || 0) === 0
  );

  handlePageChange(page: number) {
    const totalPages = this.pageInfo()?.totalPages || 1;
    if (page < 1 || page > totalPages) return;
    this.pageNo.set(page);
  }
}
